module.exports = __webpack_public_path__ + "static/media/proto_farm.b967acfb.png";